export const openOAuthPopup = (authUrl) => {
    const width = 500;
    const height = 550;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
    const popupWindow = window.open(authUrl, 'oauthPopup', `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`);
    if (!popupWindow) {
        console.error('Failed to open OAuth popup - might be blocked');
    }
    return popupWindow;
};
export const waitForOAuthResponse = async (popupWindow) => {
    return new Promise((resolve, reject) => {
        if (!popupWindow) {
            reject(new Error('Failed to open OAuth popup'));
            return;
        }
        const messageHandler = (event) => {
            // Ensure the message is from our OAuth callback
            if (event.data && event.data.type === 'OAUTH_RESPONSE') {
                window.removeEventListener('message', messageHandler);
                clearInterval(checkClosed);
                popupWindow.close();
                resolve(event.data.payload);
            }
        };
        const checkClosed = setInterval(() => {
            if (popupWindow.closed) {
                clearInterval(checkClosed);
                window.removeEventListener('message', messageHandler);
                reject(new Error('OAuth popup was closed'));
            }
        }, 1000);
        window.addEventListener('message', messageHandler);
        // Timeout after 5 minutes
        setTimeout(() => {
            clearInterval(checkClosed);
            window.removeEventListener('message', messageHandler);
            if (!popupWindow.closed) {
                popupWindow.close();
            }
            reject(new Error('OAuth flow timed out'));
        }, 5 * 60 * 1000);
    });
};
